exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nimg[data-v-bbd4621a] {\n  max-width: 300px;\n}\n.advert-wrap[data-v-bbd4621a] {\n  border-bottom: 1px solid #ccc;\n  margin-bottom: 10px;\n}\n.click[data-v-bbd4621a] {\n  cursor: pointer;\n}\n", ""]);

// exports
